import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";

class Support extends Component {
  render() {
    const services = [
      {
        icon: "book-open",
        title: "Suivi pédagogique",
        text: "Notes, parcours, discipline et informations clés accessibles rapidement pour chaque élève.",
      },
      {
        icon: "credit-card",
        title: "Paiements maîtrisés",
        text: "Historique des frais scolaires, soldes restants et reçus consultables depuis l’espace parent.",
      },
      {
        icon: "message-circle",
        title: "Communication fluide",
        text: "Une passerelle claire entre l’école, les responsables, les enseignants et les parents.",
      },
      {
        icon: "shield",
        title: "Données sécurisées",
        text: "Accès authentifié et informations centralisées pour réduire les erreurs et protéger les dossiers.",
      },
    ];

    return (
      <section className="landing-section landing-services" id="support">
        <div className="container">
          <div className="landing-section-heading text-center">
            <span className="landing-eyebrow">Services essentiels</span>
            <h2>Tout le quotidien scolaire dans un espace unique.</h2>
            <p>EviveSoma simplifie les opérations répétitives et donne une vision claire aux équipes comme aux familles.</p>
          </div>

          <div className="landing-feature-grid">
            {services.map((service) => (
              <article className="landing-feature-card" key={service.title}>
                <div className="landing-feature-icon">
                  <FeatherIcon icon={service.icon} size={24} />
                </div>
                <h3>{service.title}</h3>
                <p>{service.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default Support;
